'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var methods = ['get', 'post', 'put', 'patch', 'del'];

var formatUrl = function formatUrl(path, overwriteBasePath) {
  var urlJoin = require('url-join');

  var adjustedPath = path[0] !== '/' ? '/' + path : path;
  var basePath = overwriteBasePath || '/api';
  if (__SERVER__ && !overwriteBasePath) {
    // Prepend host and port of the API server to the path.
    basePath = urlJoin(_config2.default.protocol + '://', '' + _config2.default.apiHost + (_config2.default.apiPort ? ':' + _config2.default.apiPort : ''), _config2.default.apiRoot);
  }

  // Prepend `/api` to relative URL, to proxy to API server.
  return urlJoin(basePath, adjustedPath);
};

exports.default = methods.reduce(function (api, method) {
  return (0, _extends4.default)({}, api, (0, _defineProperty3.default)({}, method, function (path) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        params = _ref.params,
        data = _ref.data,
        overwritePath = _ref.overwritePath,
        token = _ref.token;

    return new _promise2.default(function (resolve, reject) {
      // eslint-disable-line max-len
      var request = _superagent2.default[method](formatUrl(path, overwritePath));
      if (token) request.set('Authorization', token);
      if (params) request.query(params);
      if (data) request.send(data);

      request.end(function (err) {
        var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            body = _ref2.body;

        if (err) return reject(err || body);
        return resolve(body);
      });
    });
  }));
}, {});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/api.js
// module id = 102
// module chunks = 0